import { onMounted, onUnmounted, watch } from 'vue'

import { usePortalStore } from '@/stores/portal.store'

export const withEntityChange = (types, saveAsync) => async(data, ...args) => {
  const response = await saveAsync(data, ...args)
  usePortalStore().notifyEntityChange(types, { id: response?.data?.id ?? data?.id ?? null, created: !data?.id })
  return response
}

// isOwnSave: true while the subscriber's own dialog is saving, which already refreshes it on close
export const useEntityChanges = (types, onChanged, isOwnSave = () => false) => {
  const portalStore = usePortalStore()
  onMounted(() => portalStore.subscribeEntityChanges(types))
  onUnmounted(() => portalStore.subscribeEntityChanges(types, -1))
  watch(() => portalStore.lastEntityChange, (change) => {
    if (change?.types.some(type => types.includes(type)) && !isOwnSave()) onChanged(change)
  }, { flush: 'sync' })
}
